import { render, staticRenderFns } from "./SurveysDelete.vue?vue&type=template&id=7b799fe3"
import script from "./SurveysDelete.vue?vue&type=script&lang=js"
export * from "./SurveysDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports